module.exports = __webpack_public_path__ + "static/img/img_2.705e5eb1.jpg";